import { createContext, useContext } from 'react'

export type CancelTarget = {
  id: string
  orderNumber: string
  color: string
  onSuccess?: () => void
}

const CancelDialogCtx = createContext<{ openCancel: (target: CancelTarget) => void }>({ openCancel: () => {} })

export const useCancelDialog = () => useContext(CancelDialogCtx)
export { CancelDialogCtx }
